export default __webpack_public_path__ + "static/media/378.7e27d5e6.gif";